import { BellRing, Check, Download, LogOut, Send, Smartphone } from "lucide-react";
import { useTechnicalMobileSetup } from "./technical/useTechnicalMobileSetup";
import "./technical-mobile-setup.css";

export function TechnicalMobileSetup() {
  const { identity, installPrompt, installed, subscribed, busy, message, isIos, setupComplete, install, enableNotifications, sendTest, logout } = useTechnicalMobileSetup();
  if (!identity) return null;
  return (
    <section className={`technical-mobile-setup${setupComplete ? " is-complete" : ""}`} aria-label="Telefon kurulumu">
      <div className="technical-mobile-identity">
        <Smartphone aria-hidden="true" />
        <span><strong>{identity.name}</strong><small>{identity.department === "ELECTRICAL" ? "Elektrik" : "Mekanik"} · Aktif vardiya</small></span>
      </div>
      <ol>
        <li className={installed ? "is-done" : ""}><span>{installed ? <Check /> : "1"}</span><strong>Telefona kur</strong></li>
        <li className={subscribed ? "is-done" : ""}><span>{subscribed ? <Check /> : "2"}</span><strong>Bildirimleri aç</strong></li>
      </ol>
      <div className="technical-mobile-actions">
        {!installed && installPrompt ? <button type="button" onClick={() => void install()}><Download />Telefona kur</button> : null}
        {!installed && isIos ? <small>Safari → Paylaş → Ana Ekrana Ekle</small> : null}
        {!subscribed ? <button type="button" disabled={busy} onClick={() => void enableNotifications()}><BellRing />Bildirimleri aç</button> : null}
        {subscribed ? <button type="button" disabled={busy} onClick={() => void sendTest()}><Send />Test gönder</button> : null}
        <button className="is-quiet" type="button" disabled={busy} onClick={() => void logout()}><LogOut />Çıkış</button>
      </div>
      {message ? <p role="status">{message}</p> : null}
    </section>
  );
}
